<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg5325"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs5329"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath5339"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path5337" /></clipPath></defs><g
     id="g5331"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g5333"><g
         id="g5335"
         clip-path="url(#clipPath5339)"><g
           id="g5341"
           transform="translate(160.5098,359.1904)"><path
             d="m 0,0 h -99.46 c -7.28,0 -13.18,-5.9 -13.18,-13.181 v -23.54 c 0,-7.279 5.9,-13.179 13.18,-13.179 H 72.33"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5343" /></g><g
           id="g5345"
           transform="translate(410.9302,359.1904)"><path
             d="M 0,0 H 40.02 C 47.3,0 53.2,-5.9 53.2,-13.181 v -23.54 C 53.2,-44 47.3,-49.9 40.02,-49.9 h -171.79"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5347" /></g><g
           id="g5349"
           transform="translate(380.9302,359.1904)"><path
             d="M 0,0 H -29.44"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5351" /></g><g
           id="g5353"
           transform="translate(430.0684,309.29)"><path
             d="M 0,0 V -270.295 H -348.137 V -88.813"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5355" /></g><g
           id="g5357"
           transform="translate(81.9316,250.4834)"><path
             d="M 0,0 V 58.807"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5359" /></g><g
           id="g5361"
           transform="translate(279.1592,424.0908)"><path
             d="M 0,0 C 25.775,-33.84 -12.478,-72.093 -46.318,-46.319 -72.093,-12.48 -33.84,25.775 0,0 Z m 53.005,-23.16 c 0,3.425 -0.248,6.79 -0.687,10.096 L 71.47,6.332 c 2.957,2.995 3.549,7.597 1.444,11.242 l -12.76,22.102 c -2.105,3.644 -6.386,5.433 -10.458,4.37 L 23.321,37.158 C 18.002,41.264 12.131,44.683 5.83,47.279 l -7.215,26.259 c -1.115,4.059 -4.805,6.871 -9.014,6.871 h -25.52 c -4.209,0 -7.899,-2.812 -9.015,-6.871 L -52.148,47.279 C -58.45,44.683 -64.321,41.264 -69.64,37.158 l -26.374,6.888 c -4.072,1.063 -8.354,-0.726 -10.458,-4.37 l -12.76,-22.102 c -2.105,-3.645 -1.514,-8.247 1.443,-11.242 l 19.152,-19.396 c -0.438,-3.306 -0.686,-6.671 -0.686,-10.096 0,-3.425 0.248,-6.79 0.686,-10.095 l -19.152,-19.396 c -2.957,-2.995 -3.548,-7.597 -1.443,-11.243 l 12.76,-22.1 c 2.104,-3.646 6.386,-5.435 10.458,-4.371 l 26.374,6.887 c 5.319,-4.104 11.19,-7.524 17.492,-10.12 l 7.214,-26.258 c 1.116,-4.059 4.806,-6.873 9.015,-6.873 h 25.52 c 4.209,0 7.899,2.814 9.014,6.873 l 7.215,26.258 c 6.302,2.596 12.173,6.016 17.492,10.12 l 26.374,-6.887 c 4.072,-1.064 8.353,0.725 10.458,4.371 l 12.76,22.1 c 2.105,3.646 1.513,8.248 -1.444,11.243 l -19.151,19.396 c 0.438,3.305 0.686,6.67 0.686,10.095 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5363" /></g><g
           id="g5365"
           transform="translate(166.0112,199.8477)"><path
             d="m 0,0 v 0 c 0,-9.029 7.32,-16.349 16.349,-16.349 h 147.28 c 9.029,0 16.349,7.32 16.349,16.349 0,9.029 -7.32,16.349 -16.349,16.349 H 16.349 C 7.32,16.349 0,9.029 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5367" /></g><path
           d="M 188.422,38.995 H 323.577 V 183.499 H 188.422 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path5369" /><g
           id="g5371"
           transform="translate(256,38.9951)"><path
             d="M 0,0 V 141.337"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5373" /></g><g
           id="g5375"
           transform="translate(401.083,97.917)"><path
             d="m 0,0 h -45.792 c -2.714,0 -4.914,2.2 -4.914,4.914 v 55.037 c 0,2.714 2.2,4.914 4.914,4.914 H 0 c 2.714,0 4.914,-2.2 4.914,-4.914 V 4.914 C 4.914,2.2 2.714,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5377" /></g><g
           id="g5379"
           transform="translate(156.709,97.917)"><path
             d="m 0,0 h -45.792 c -2.714,0 -4.914,2.2 -4.914,4.914 v 55.037 c 0,2.714 2.2,4.914 4.914,4.914 H 0 c 2.714,0 4.914,-2.2 4.914,-4.914 V 4.914 C 4.914,2.2 2.714,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5381" /></g><g
           id="g5383"
           transform="translate(47.8687,34.0811)"><path
             d="m 0,0 v -21.667 c 0,-2.714 2.2,-4.914 4.914,-4.914 h 406.435 c 2.713,0 4.914,2.2 4.914,4.914 V 0 c 0,2.714 -2.201,4.914 -4.914,4.914 H 4.914 C 2.2,4.914 0,2.714 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5385" /></g></g></g></g></svg>
</template>
